// src/components/common/Toast.js
import Swal from "sweetalert2";

// 🔹 BASE TOAST
const baseToast = (title, icon = "success", position = "top-end") => {
  Swal.fire({
    toast: true,
    position,
    icon,
    title,
    showConfirmButton: false,
    timer: 2500,
    timerProgressBar: true,
    background: "#fff",
    color: "#000",
    customClass: {
      popup: "rounded-md shadow-md",
    },
  });
};

// ✅ SUCCESS
export const showSuccessToast = (title) => {
  baseToast(title, "success");
};

// ❌ ERROR
export const showErrorToast = (title) => {
  baseToast(title || "Something went wrong", "error");
};

// ⚠️ WARNING
export const showWarningToast = (title) => {
  baseToast(title, "warning");
};

// ℹ️ INFO
export const showInfoToast = (title) => {
  baseToast(title, "info");
};

export const showToast = baseToast;